/* Veritais — Farbauswahl auf der Produktkachel */
(function () {
  if (window.__vtSwatchesInit) return;
  window.__vtSwatchesInit = true;

  function cardOf(el) {
    return el.closest('.card-wrapper') || el.closest('.card') || el.closest('li');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vt-swatches] .vt-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = cardOf(btn);
    if (!card) return;

    var group = btn.closest('[data-vt-swatches]');
    group.querySelectorAll('.vt-swatch').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var img = card.querySelector('.card__media img, .card__inner img');
    var src = btn.getAttribute('data-vt-img');
    if (img && src) {
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }

    var url = btn.getAttribute('data-vt-url');
    if (url) {
      card.querySelectorAll('a[href]').forEach(function (a) {
        if (a.classList.contains('vt-swatch')) return;
        a.setAttribute('href', url);
      });
    }
  }, true);
})();
